// src/firebase.js

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCpN5zBJF5fE4iGGkXzBxOkoYGS3cQTsUs",
  authDomain: "rootlyhomoeo.firebaseapp.com",
  projectId: "rootlyhomoeo",
  storageBucket: "rootlyhomoeo.firebasestorage.app",
  messagingSenderId: "481999212747",
  appId: "1:481999212747:web:cea65928e96f14a0e04b4e",
  measurementId: "G-JFDZST0K4S"
};

/* Initialize Firebase */
const app = initializeApp(firebaseConfig);

/* Analytics */
const analytics = getAnalytics(app);

/* Firestore Database */
const db = getFirestore(app);

export { db, analytics };